// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"83":"828b6476","118":"9a6fe598","180":"fab8c0f0","380":"7b9c2d0f","473":"c697163c","533":"b892478d","617":"1049484d","651":"df95b4c0","716":"13d5de22","728":"58bc21d3","729":"f742f21b","772":"107013c8","836":"cb73b041","893":"7900c30e","896":"6d0d4385","923":"272cf070"}[chunkId] + ".chunk.js";
};